module.exports = __webpack_public_path__ + "img/logo-zc-dark.9b20b602.webp";